import React from "react";
import * as moment from "moment";

import { NavLink } from "react-router-dom";

import { getImageURL } from "../../utils/functions";

const BlogSidebar = ({ blogPosts, assets }) => (
  <aside className="col-lg-5 col-xl-4">

    <div className="widget widget_recent_posts">
      <h3 className="widget-title">Latest Resources</h3>
      <ul className="list-unstyled">
        {blogPosts.splice(0, 3).map(({ fields, sys }, index) => {
          const { title, publishDate, heroImage } = fields;

          return (
            <li key={`sidebar-${index}`} className="media">
              <NavLink to={`resources/article/${sys.id}`}>
                <a className="">
                  <img src={getImageURL(assets, heroImage.sys.id)} alt="img" />
                </a>
              </NavLink>
              <div className="media-body">
                <p className="item-meta mb-2">
                  {moment(publishDate).format("DD MMMM, YYYY")}
                </p>
                <h4>
                  <NavLink to={`resources/article/${sys.id}`}>
                    <a>{title}</a>
                  </NavLink>
                </h4>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  </aside>
);

export default BlogSidebar;
